import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';

import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CanActivate, ActivatedRoute } from '@angular/router';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import * as Auth from '../actions/auth.actions';
import * as fromAuth from '../reducers';
import * as ProjectActions from '../../project/actions/project.actions';

@Injectable()
export class AuthGuard implements CanActivate {

  // Private Variables
  private activity: string = null;
  private project_id: number = null;
  private ratingId: number = null;
  private validProject: boolean = false;

  // Public Observables
  private registerType$: Observable<any> = this.store.select(state => state.auth.login.registerType);
  private isActivate$: Observable<any> = this.store.select(state => state.auth.login.isActivate);
  // Constructor
  constructor(private store: Store<fromAuth.State>) {}

  // Can Activate
  canActivate(route: ActivatedRouteSnapshot, stateSnapshot: RouterStateSnapshot): Observable<boolean> {
    // We need to save the path
    const project = route.url[0].path === 'project';
    // Return
    return this.store.select(state => state.auth.login.token)
      .map(authed => {
        // If we are not authed and we are trying to enter to a project
        if (!authed && project) {
          this.redirectProperLoginType(stateSnapshot.url);
          return false;
        }
        // If we are not authed and not trying to enter to a project
        else if (!authed && !project) {
          this.store.dispatch(new Auth.LoginRedirect());
          return false;
        } // check if participant have access to the project
        else if (authed && project) {
          this.checkActivateParticipant(stateSnapshot.url);
          return true;
        }
        return true;
      })
      .take(1);
  }

  // Get URL params
  private getURLParams(url: string) {
    const projectRoute = url.split('/');
    this.validProject = /^([0-9]+)$/.test(projectRoute[2]);

    // Removing social media adds
    const lastElement = projectRoute[projectRoute.length - 1];
    const lastActivity = lastElement.split('?');
    const activity = (lastActivity.length > 1 && ['sorting', 'rating', 'sorting-rating', 'participant-questions', 'brainstorming'].includes(lastActivity[0])) ? lastActivity[0] : projectRoute[3];

    // Get values from store
    this.activity = activity;
    this.project_id = parseInt(projectRoute[2], 10);

    if (projectRoute.length > 4 && projectRoute[4] !== 'preview') this.ratingId = parseInt(projectRoute[4], 10);
    if (projectRoute.length > 4 && projectRoute[4] === 'preview') sessionStorage.setItem('csi-participants-session-preview', '1');
    if (projectRoute.length > 5) sessionStorage.setItem('csi-participants-session-preview', '1');
  }

  private checkActivateParticipant(url: string) {
      this.getURLParams(url);

      if (this.validProject) {
        // Get if participant is activate
        this.store.dispatch(new Auth.CheckActivateParticipant(this.project_id));
        this.isActivate$.subscribe(activate => {
          if (activate) {
            if (!activate.access) {
              this.store.dispatch(new Auth.DashboardRedirect());
            }
          }
        });
      } else this.store.dispatch(new Auth.DashboardRedirect());
  }

  // Choose the right Login type
  private redirectProperLoginType(url: string): void {
    this.getURLParams(url);

    if (this.validProject) {
      // Get Available language
      this.store.dispatch(new ProjectActions.GetAvailableLanguage(this.project_id));

      if (sessionStorage.getItem('csi-participants-session-preview')) {
        this.store.dispatch(new Auth.AnonymousLoginPreview({ project_id: this.project_id, activity: this.activity, ratingId: this.ratingId }));
      } else {
        if (this.activity) {

          // Get register type
          this.store.dispatch(new Auth.GetRegisterType({
            project_id: this.project_id,
            activity: this.activity,
            ratingId: this.ratingId
          }));

          // Choose login
          this.registerType$.subscribe(registerType => {
            if (registerType) {
              if (registerType.canRegister) {
                if (!registerType.blockNewRegistration) {
                  // Login
                  switch (registerType.identifierType) {
                    // Email or Identifier
                    case 1:
                      this.store.dispatch(new Auth.LoginEmailIdentifierRedirect());
                      break;

                    // Email Address
                    case 2:
                      this.store.dispatch(new Auth.LoginEmailRedirect());
                      break;

                    // Email Address
                    case 3:
                      this.store.dispatch(new Auth.LoginIdentifierRedirect());
                      break;

                    // Anonymous
                    case 4:
                      if (registerType.assignedAnonUsername === 0) {
                        if (this.ratingId !== null)
                          this.store.dispatch(new Auth.AnonymousLoginAssignedParticipationOnly({
                            project_id: this.project_id,
                            activity: this.activity,
                            ratingId: this.ratingId
                          }));
                        else
                          this.store.dispatch(new Auth.AnonymousLoginAssignedParticipationOnly({
                            project_id: this.project_id,
                            activity: this.activity
                          }));
                      } else this.store.dispatch(new Auth.LoginAnonymousRedirect());
                      break;
                  }
                } else this.store.dispatch(new Auth.LoginRedirect());
              } else this.store.dispatch(new Auth.NoActivitiesRedirect(registerType.projectInfo));
            }
          });
        } else {
          sessionStorage.setItem('csi-participants-session-project', this.project_id.toString());
          this.store.dispatch(new Auth.LoginRedirect());
        }
      }
    } else this.store.dispatch(new Auth.LoginRedirect());
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/services/auth-guard.service.ts